import { render, staticRenderFns } from "./TasksScheduleDetails.vue?vue&type=template&id=889c768a&scoped=true"
import script from "./TasksScheduleDetails.vue?vue&type=script&lang=js"
export * from "./TasksScheduleDetails.vue?vue&type=script&lang=js"
import style0 from "./TasksScheduleDetails.vue?vue&type=style&index=0&id=889c768a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889c768a",
  null
  
)

export default component.exports